<ul class="lang-selector-list">
  @for (lang of languages(); track lang.code) {
    <li
      class="lang-selector-item"
      [class.lang-selector-item-sidebar]="isInSidebar()"
    >
      @if (lang.code !== languageService.getCurrentLang()) {
        <a
          class="lang-selector-link g-main-link g-main-link-black"
          [class.lang-selector-link-sidebar]="isInSidebar()"
          [href]="lang.link"
        >
          {{ lang.label }}
        </a>
      } @else {
        <span
          class="lang-selector-link lang-selector-link-active"
          [class.lang-selector-link-sidebar]="isInSidebar()"
        >
          {{ lang.label }}
        </span>
      }
    </li>
  }
</ul>
